'use client';

import { useTranslations } from 'next-intl';
import { useUnit } from 'effector-react';
import classNames from 'classnames';
import { Button, ButtonType } from '@nx-frontend/shared/ui/button';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { $ModalStore, closeModalEvent } from '@nx-frontend/shared/ui/modal';
import { PublishInformPayload, PopupType } from '@nx-frontend/shared/types';

export function PublishInformPopup() {
  const [modalStore, closeModal] = useUnit([$ModalStore, closeModalEvent]);

  const t = useTranslations('customizer');

  const modal = modalStore.find((modal) => modal.payload && modal.payload.payloadType === PopupType.PUBLISH_INFORM);
  const payload = modal?.payload as PublishInformPayload;

  if (!payload) {
    return null;
  }

  const isVisible = payload.data.isVisible;
  const onSubmit = payload.data.onSubmit;
  const submitText = isVisible ? t('customizer-publish_as_invisible') : t('customizer-proceed_to_publish');
  const nodeName = payload.data.nodeName;

  return (
    <div className="max-w-[500px]">
      <div
        className={classNames('px-3 py-2 my-6 flex', {
          'bg-yellow-50': isVisible,
          'bg-teal-50': !isVisible,
        })}
      >
        <div className="mr-2">
          <Icon icon={IconsMap.INFO} className="w-4 h-4" />
        </div>
        {isVisible && (
          <div>
            {t.rich('customizer-unpublished_item_permissions_description', {
              nodeName,
              strong: (chunk) => <strong>{chunk}</strong>,
            })}
          </div>
        )}
        {!isVisible && <div>{t('customizer-unpublished_item_permissions_description2', { nodeName })}</div>}
      </div>
      <div className="mt-5 flex gap-2 justify-end">
        <Button type={ButtonType.STROKED} onClick={closeModal}>
          {t('customizer-cancel')}
        </Button>
        <Button type={ButtonType.FLAT} onClick={onSubmit}>
          {submitText}
        </Button>
      </div>
    </div>
  );
}
